"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReportCheckPanelWrapper = exports.MediaUploaderWrapper = exports.MainContentWrapper = exports.Label = exports.Description = exports.ButtonsContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _palette = require("../../styles/palette");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ReportCheckPanelWrapper = exports.ReportCheckPanelWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__ReportCheckPanelWrapper",
  componentId: "sc-43vv6w-0"
})(["width:100%;height:100%;overflow-y:auto;display:flex;flex-direction:column;"]);
var MainContentWrapper = exports.MainContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__MainContentWrapper",
  componentId: "sc-43vv6w-1"
})(["flex:1;overflow-y:auto;"]);
var Description = exports.Description = _styledComponents["default"].p.withConfig({
  displayName: "styles__Description",
  componentId: "sc-43vv6w-2"
})(["font-size:18px;color:", ";padding-bottom:16px;font-size:14px;"], _palette.commonPalette.textPrimary);
var ButtonsContainer = exports.ButtonsContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__ButtonsContainer",
  componentId: "sc-43vv6w-3"
})(["display:flex;justify-content:flex-start;margin-top:24px;flex-direction:row;gap:16px;"]);
var MediaUploaderWrapper = exports.MediaUploaderWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__MediaUploaderWrapper",
  componentId: "sc-43vv6w-4"
})(["margin-top:21px;flex:1;"]);
var Label = exports.Label = _styledComponents["default"].p.withConfig({
  displayName: "styles__Label",
  componentId: "sc-43vv6w-5"
})(["font-size:16px;font-family:'Lato';color:", ";padding-bottom:8px;"], _palette.commonPalette.textSecondary);
//# sourceMappingURL=styles.js.map